import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  courses: [],
  modules: [],
  videos: [],
  loading: false,
  error: null
};

const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setCourses: (state, action) => {
      state.courses = action.payload;
    },
    setModules: (state, action) => {
      state.modules = action.payload;
    },
    setVideos: (state, action) => {
      state.videos = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setCourses, setModules, setVideos, setLoading, setError } = coursesSlice.actions;
export default coursesSlice.reducer;
